import React from "react"

import { COLORS, BORDER_RADIUS, GRADIENT } from "../styles/constants"
import "../styles/button.css"

const Button = ({ children }) => (
  <button
    style={{
      padding: ".5rem 2.5rem",
      marginBottom: ".5rem",
      color: COLORS.darkRed,
      fontWeight: 700,
      background: GRADIENT,
      borderRadius: BORDER_RADIUS,
      borderWidth: 1,
      borderColor: COLORS.darkRed,
      cursor: "pointer",
    }}
  >
    {children}
  </button>
)

export default Button
